import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { ImportMode, ImportResultResponse } from '../models/import-export.model';

/**
 * Flujo combinado contactos + empresas (`/api/crm/import-export`).
 * Cada fila puede traer datos de un contacto, de una empresa o de ambos —
 * cuando trae los dos, además crea/actualiza la asociación contact_company.
 * Todos los endpoints requieren rol Admin o superior.
 */
@Injectable({ providedIn: 'root' })
export class CrmImportExportApiService {
  private readonly apiUrl = `${environment.apiUrl}api/crm/import-export`;

  constructor(private http: HttpClient) { }

  // GET /api/crm/import-export/export — CSV con todas las asociaciones + huérfanos
  exportCombinedCsv(): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/export`, { responseType: 'blob' });
  }

  // GET /api/crm/import-export/import/template — header-only CSV
  downloadCombinedTemplate(): Observable<Blob> {
    return this.http.get(`${this.apiUrl}/import/template`, { responseType: 'blob' });
  }

  // POST /api/crm/import-export/import?mode=...
  importCombinedCsv(file: File, mode: ImportMode = 'SKIP'): Observable<ImportResultResponse> {
    const form = new FormData();
    form.append('file', file);
    const params = new HttpParams().set('mode', mode);
    return this.http.post<ImportResultResponse>(`${this.apiUrl}/import`, form, { params });
  }
}
